import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("coachiq_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// -------------------- Payments --------------------
export const payments = {
  config: () => api.get("/payments/config").then((r) => r.data),
  checkout: (lookup_key = "founding_coach_lifetime") =>
    api
      .post("/payments/checkout", {
        lookup_key,
        origin_url: window.location.origin,
      })
      .then((r) => r.data),
  status: (session_id) =>
    api.get(`/payments/status/${session_id}`).then((r) => r.data),
  portal: (return_url) =>
    api.post("/payments/portal", { return_url }).then((r) => r.data),
  history: () => api.get("/payments/my").then((r) => r.data),
};

